exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/inetpub/wwwroot/kaizen-ng/node_modules/exports-loader?module.exports.toString()!D:/inetpub/wwwroot/kaizen-ng/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!D:/inetpub/wwwroot/kaizen-ng/node_modules/postcss-loader?{"ident":"postcss"}!D:/inetpub/wwwroot/kaizen-ng/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/baMenu/baMenu.scss
// module id = ../../../../exports-loader/index.js?module.exports.toString()!../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/app/theme/components/baMenu/baMenu.scss
// module chunks = main